import React from 'react';
import {connect} from 'react-redux';
import {RouteComponentProps, withRouter} from 'react-router-dom';

import {_logout} from '@shared/store/actions/AuthActions';

import AuthUtils from '../../../utils/AuthUtils';
import NavRoutes from '../../../constants/route/NavRoutes';
import Loader from '@components/framework/loader/Loader';
import './Logout.scss';

interface LogoutProps {
  logout(): void;
}

class Logout extends React.PureComponent<LogoutProps & RouteComponentProps> {
  constructor(props: LogoutProps & RouteComponentProps) {
    super(props);
    this.clearSession = this.clearSession.bind(this);
  }

  componentDidMount() {
    this.clearSession();
  }

  clearSession() {
    const {history, logout} = this.props;
    if (typeof logout === 'function') {
      logout();
    }
    AuthUtils.resetPortal();
    setTimeout(() => {
      history.push(`/${NavRoutes.PUBLIC.LOGIN}`);
    }, 1000);
  }

  render() {
    return (
      <>
        <div className="flex-centering">
          <Loader size={56} color="primary" />
        </div>
        <div className="logout-text">Logging out...</div>
      </>
    );
  }
}

export default connect(() => ({}), {
  logout: _logout
})(withRouter(Logout));
